
import React from "react";

interface DemoUsageIndicatorProps {
  show: boolean;
}

const DemoUsageIndicator = ({ show }: DemoUsageIndicatorProps) => {
  if (!show) return null;

  return (
    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg text-center">
      <p className="text-sm text-blue-800">
        You've used your free demo. <span className="font-medium">Sign up</span> to get 3 free requests per month!
      </p>
    </div>
  );
};

export default DemoUsageIndicator;
